export default __webpack_public_path__ + "static/media/CNo.79-5.5becc548.jpg";